//
// Copyright 2020 DXOS.org
//

import { lazy } from 'react';

export const ConfigArticle = lazy(() => import('./ConfigArticle/index.ts'));
export const DiagnosticsArticle = lazy(() => import('./DiagnosticsArticle/index.ts'));
export const LoggingArticle = lazy(() => import('./LoggingArticle/index.ts'));
export const StorageArticle = lazy(() => import('./StorageArticle/index.ts'));
export const SqliteArticle = lazy(() => import('./SqliteArticle/index.ts'));
